import React, { Fragment } from "react";
import { connect } from "react-redux";
import { closeModal } from "ducks/matchingGifts";
import OrangeCheck from "shared/ui/svg-icons/OrangeCheck";
import { FormattedNumber } from "react-intl";
import { isEmptyValue, hasValue } from "../../utils/utils";
import GivingButtonV2 from "shared/components/giving-form-v2/App/GivingButtonV2";
import CommonDialog from "src/shared/components/dialogs/CommonDialog";

const MatchingGiftDescriptionModal = ({
  currentMatchingGift,
  currencyCode,
  sectionId,
  modalOpen,
  onCloseModal,
  selectedModal,
}) => {
  const {
    title,
    complete,
    expired,
    active,
    full_description,
    image_filename,
    type,
    amount_raised,
    money_goal,
    unique_donor_count,
    donation_count,
    participation_goal,
    donation_goal,
    campaign,
  } = currentMatchingGift;

  const isModalOpen = (selectedModal, currentModal, modalOpen) =>
    modalOpen && selectedModal === currentModal;

  return (
    <CommonDialog
      open={isModalOpen(selectedModal, `readMoreModal-${sectionId}`, modalOpen)}
      onClose={onCloseModal}
      title={title}
      showCancelButton={true}
      cancelText={"Close"}
      onCancel={onCloseModal}
      domProps={{ className: "matching-gifts-modal" }}>
      <div className="gift-description-modal">
        {isEmptyValue(image_filename.url) && <div className="modal-image no-image" />}
        {hasValue(image_filename.url) && (
          <img className="modal-image" src={image_filename.url} />
        )}

        <div className="modal-description">{full_description}</div>
        <div className="dollars">
          {type === "Participation Based" ? (
            <Fragment>
              {unique_donor_count} / {participation_goal}
              <span className="italic-text"> Donors</span>
            </Fragment>
          ) : type === "Donation Based" ? (
            <Fragment>
              {donation_count} / {donation_goal}
              <span className="italic-text">
                {" "}
                {donation_count === 1 ? "Donation" : "Donations"}
              </span>
            </Fragment>
          ) : (
            <Fragment>
              <FormattedNumber
                value={amount_raised}
                currencyDisplay="symbol"
                currency={currencyCode}
                style="currency"
                minimumFractionDigits="0"
                maximumFractionDigits="0"
              />
              <span> / </span>
              <FormattedNumber
                value={money_goal}
                currencyDisplay="symbol"
                currency={currencyCode}
                style="currency"
                minimumFractionDigits="0"
                maximumFractionDigits="0"
              />
            </Fragment>
          )}
        </div>
        {(complete || expired) && (
          <div className="complete-icon">
            <OrangeCheck />
            &nbsp; Complete
          </div>
        )}
        {active && (
          <GivingButtonV2
            campaign={campaign}
            cssClasses={"match-gift-wide-button"}
            buttonText={"Match Gift"}
          />
        )}
        {!active && !complete && !expired && (
          <div className="complete-icon">Starting Soon</div>
        )}
      </div>
    </CommonDialog>
  );
};

const mapStateToProps = ({ matchingGifts }) => {
  const { modalOpen, selectedModal, currentMatchingGift } = matchingGifts;

  return { modalOpen, selectedModal, currentMatchingGift };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onCloseModal: () => dispatch(closeModal()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MatchingGiftDescriptionModal);
